export default __webpack_public_path__ + "static/media/47.94ef9a9a.jpg";